import { useState } from "react"
import { NavLink } from "react-router-dom"
import { css } from "@emotion/react"
import { PartCategory, usePartCategories, usePartChemicals } from "@ncs/ncs-api/portal-apps"
import { useHistory } from "react-router-dom"
import { Icon, TrackingEvent, Flag, useIsFeatureFlagOn } from "@ncs/web-legos"
import { useAnalytics } from "~/hooks/useAnalytics"

export const SiteNavigationEcomm: React.FC = () => {
	const [toggleCategories, setToggleCategories] = useState(false)
	const [toggleChemicals, setToggleChemicals] = useState(false)
	const history = useHistory()
	const [categories] = usePartCategories()
	const [chemicals] = usePartChemicals()
	const { trackEvent } = useAnalytics()
	const onToggleParts = () => {
		if (!toggleCategories) {
			trackEvent(TrackingEvent.PARTS_CATEGORY)
		}
		setToggleCategories(!toggleCategories)
	}

	const onToggleChemicals = () => {
		if (!toggleChemicals) {
			trackEvent(TrackingEvent.CHEMISTRY_CATEGORY)
		}
		setToggleChemicals(!toggleChemicals)
	}

	const hideTrending = useIsFeatureFlagOn(Flag.VITE_FLAG_HIDE_TRENDING)

	const trendingHandler = () => {
		history.push("/shop/search?featured=true")
		trackEvent(TrackingEvent.TRENDING)
	}

	const clearanceHandler = () => {
		history.push("/shop/search?clearance=true")
		trackEvent(TrackingEvent.CLEARANCE_NAV_BAR)
	}

	return (
		<nav css={navContainer}>
			<ul>
				<li css={navElement}>
					<button onClick={onToggleChemicals}>
						<div css={category}>
							Chemicals
							{toggleChemicals ?
								<Icon icon="chevron-up" color="text" />
							:	<Icon icon="chevron-down" color="text" />}
						</div>
					</button>
					{toggleChemicals && (
						<ul>
							{(chemicals ?? []).map((chemical: PartCategory) => (
								<li key={chemical?.id} css={subCategories}>
									<NavLink
										to={`/shop/search?categories=${chemical?.id}&ordering=title`}
									>
										{chemical?.name}
									</NavLink>
								</li>
							))}
						</ul>
					)}
				</li>
				<li css={navElement}>
					<button onClick={onToggleParts}>
						<div css={category}>
							Parts
							{toggleCategories ?
								<Icon icon="chevron-up" color="text" />
							:	<Icon icon="chevron-down" color="text" />}
						</div>
					</button>
					{toggleCategories && (
						<ul>
							{(categories ?? []).map((category: PartCategory) => (
								<li key={category?.id} css={subCategories}>
									<NavLink
										to={`/shop/search?categories=${category?.id}&ordering=title`}
									>
										{category?.name}
									</NavLink>
								</li>
							))}
						</ul>
					)}
				</li>
				{!hideTrending && (
					<li css={navElement}>
						<button onClick={trendingHandler} css={buttonStyle}>
							Trending
						</button>
					</li>
				)}
				<li css={navElement}>
					<button onClick={clearanceHandler} css={buttonStyle}>
						Clearance
					</button>
				</li>
			</ul>
		</nav>
	)
}

const navContainer = css`
	padding-right: 2rem;
`

const navElement = css`
	font-weight: 500;
	padding: 0.5rem;

	a {
		font-weight: 500;
		color: #00050a;
		text-decoration: none;
	}

	&:first-of-type {
		margin-top: 1.5rem;
	}

	button {
		background: none;
		border: none;
		cursor: pointer;
		padding: 0;
		width: 100%;
	}
`

const category = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #00050a;
	font-size: 1rem;
`

const subCategories = css`
	padding: 0.6rem;
	margin-left: 1rem;

	a {
		color: #00050a;
		font-size: 1rem;
		font-weight: 400;
		text-decoration: none;
	}
`

const buttonStyle = css`
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	font: inherit;
	color: inherit;
	cursor: pointer;
	outline: none;
	text-align: inherit;
	display: inline-block;
`
